import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
// @ts-ignore
import style from './NumberInput.module.scss?module';
import clsx from 'clsx';

interface Props {
  invalid?: boolean;
  loading?: boolean;
  inputValue?: number;
  className?: string;
  onChange?: (value: number | undefined) => any;
  onBlur?: (value: number | undefined) => any;
}

const NumberInput = ({
  invalid,
  loading,
  inputValue,
  className,
  onChange,
  onBlur,
}: Props) => {
  const [value, setValue] = useState<number | string>(inputValue ?? '');
  const [contextValue, setContextValue] = useState<number | undefined>(
    inputValue
  );
  const [previousValue, setPreviousValue] = useState<number | string>('');

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const rawValue = event.currentTarget.value;

    if (rawValue.length === 0) {
      setValue('');
    } else {
      const numValue = Number(rawValue);
      if (numValue === 0) {
        setValue('');
        return;
      }
      setValue(numValue);
    }

    if (onChange) {
      const finalValue = rawValue.length < 1 ? undefined : Number(rawValue);
      onChange(finalValue);
    }
  };

  const handleInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (isNaN(+event.key)) {
      event.preventDefault();
    }
  };

  const handleInputBlur = () => {
    if (!onBlur) {
      return;
    }

    onBlur(value.toString().length < 1 ? undefined : Number(value));
  };

  useEffect(() => {
    if (inputValue !== contextValue) {
      if (typeof value === 'number' || value.toString().length > 0) {
        setPreviousValue(value);
      }

      setValue(inputValue ?? '');

      setContextValue(inputValue);
    }
  }, [inputValue, contextValue]);

  return (
    <div className={clsx('position-relative w-100 h-100')}>
      <OverlayTrigger
        placement="top"
        overlay={
          invalid ? (
            <Tooltip>
              <small>
                Reduced to available quantity.{' '}
                {previousValue && String(previousValue).length > 0
                  ? ` requested: ${previousValue}`
                  : ''}
              </small>
            </Tooltip>
          ) : (
            <Tooltip className="d-none"></Tooltip>
          )
        }
      >
        <input
          type="number"
          min={0}
          value={value}
          onChange={handleInputChange}
          onKeyPress={handleInput}
          onBlur={handleInputBlur}
          className={clsx(
            'w-100 h-100 form-control text-center border-0 fw-bold',
            style.numberInput,
            invalid ? 'bg-light-red' : '',
            className
          )}
          placeholder="-"
        />
      </OverlayTrigger>
      {loading && (
        <div className="position-absolute start-0 top-0 bottom-0 d-flex align-items-center">
          <LoadingSpinner className="ms-2" size="sm" />
        </div>
      )}
    </div>
  );
};

export default NumberInput;
